import React, { useState } from 'react';
import { useRedirect, useNotify, useTranslate } from 'react-admin';
import {
  isTicketRefunded,
  hasTicketRefundRequest,
  resolveTicketRefundPath,
  getTicketSaleId,
} from '../../utils/ticketsUtils';
import { getSaleById } from '../../services/salesService';

/**
 * Tickets listesinde İade rozeti — tıklayınca ödeme/iade kaydına gider.
 */
const TicketRefundCell = ({ ticket }) => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const refunded = isTicketRefunded(ticket);
  const requested = hasTicketRefundRequest(ticket);

  if (!refunded && !requested) {
    return <span style={{ color: '#999' }}>-</span>;
  }

  const label = refunded
    ? translate('tickets.refunded', { _: 'İade edildi' })
    : translate('tickets.refund_pending', { _: 'İade bekliyor' });
  const bg = refunded ? '#6a1b9a' : '#ed6c02';

  const go = async (e) => {
    e?.stopPropagation?.();
    if (loading) return;

    const direct = resolveTicketRefundPath(ticket);
    if (direct) {
      redirect(direct);
      return;
    }

    const saleId = getTicketSaleId(ticket);
    if (!saleId) {
      notify('Bu bilet için iade/ödeme kaydı bulunamadı.', { type: 'warning' });
      return;
    }

    setLoading(true);
    try {
      const sale = await getSaleById(saleId);
      const payment =
        typeof sale?.payment === 'string' ? sale.payment : sale?.payment?.id;
      if (payment) {
        redirect(`/payments/${encodeURIComponent(payment)}/show`);
        return;
      }
      const rrId = ticket?.extras?.refundRequestId;
      if (rrId) {
        redirect(`/refundRequests?highlight=${encodeURIComponent(rrId)}`);
        return;
      }
      notify('Bu bilet için ödeme kaydı bulunamadı.', { type: 'warning' });
    } catch {
      notify('İade bilgisi açılamadı.', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={go}
      disabled={loading}
      title="İade bilgisine git"
      style={{
        backgroundColor: bg,
        color: '#fff',
        border: 'none',
        borderRadius: 5,
        padding: '3px 10px',
        minWidth: 60,
        cursor: loading ? 'wait' : 'pointer',
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      {loading ? '…' : label}
    </button>
  );
};

export default TicketRefundCell;
